/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-newline */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';
import { Card, CardBody } from 'reactstrap';
import Title from '@components/Title';
import cx from 'classnames';

/**
 * Takes card data and renders it
 * as a Gallery Image for a Media Gallery.
 */
const GalleryImage = ({ card }) => {
  const { border } = card;
  const customImage = getImage(card.cardImage?.gatsbyImageData || card.image?.gatsbyImageData)['images']['fallback']['src'];
  return (
    <div style={{ padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      { (card.button?.buttonUrl ? (
        <Link to={card.button.buttonUrl} className="link-color">
          <Card className={cx('mb-3', 'data-cy-card-button', 'content-card', 'content-card-gallery-image', border ? 'card-border' : 'card-no-border')} style={{ width: 300, height: 300, backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage: `url(${customImage})` }}>
            {card.titleDisplay && (
            <CardBody className={cx('card-class', 'rounded-bottom', border ? 'card-border' : 'card-no-border')} style={{ paddingBottom: '20px', backgroundColor: 'white', position: 'absolute', bottom: 0, height: '100px', width: '100%' }}>
              <Title title={card.titleDisplay} titleSize="h2" classes="mb-0 card-title-media-gallery" />
            </CardBody>
            )}
          </Card>
        </Link>
      ) : (
        <Card className={cx('mb-3', 'data-cy-card-button', 'content-card', 'content-card-gallery-image', border ? 'card-border' : 'card-no-border')} style={{ width: 300, height: 300, backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage: `url(${customImage})` }}>
          {card.titleDisplay && (
          <CardBody className={cx('card-class', 'rounded-bottom', border ? 'card-border' : 'card-no-border')} style={{ paddingBottom: '20px', backgroundColor: 'white', position: 'absolute', bottom: 0, height: '100px', width: '100%' }}>
            <Title title={card.titleDisplay} titleSize="h2" classes="mb-0 card-title-media-gallery" />
          </CardBody>
          )}
        </Card>
      ))}
    </div>
  );
};

GalleryImage.defaultProps = {
  card: null,
};

GalleryImage.propTypes = {
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  card: PropTypes.objectOf(PropTypes.any),
};

export default GalleryImage;
